import React from 'react';
import { Row, Col } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  FormCol3,
  FormCol9,
  FormRow,
  FormCol4,
  FormCol12,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectCollector,
  FieldSelectProfession,
  FieldSelectWasteReceptionPoint,
} from 'shared-pages';

import { useRootStore } from 'store';
import { FieldSelectXAxis } from './fs-x-axis';
import { FieldSelectYAxis } from './fs-y-axis';
import { Field } from 'formik';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  console.log('$$$ collections where', values);
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.collectionPointId) {
      where = { ...where, collectionPointId: values.collectionPointId };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'dateCollected'),
      };
    }
    if (values.collectorId) {
      where = { ...where, collectorId: values.collectorId };
    }
    if (values.wastereceptionpointId) {
      where = { ...where, wastereceptionpointId: values.wastereceptionpointId };
    }

    if (values.regionId) {
      where = { ...where, regionId: values.regionId };
    }
    if (values.wasteOriginTypeId) {
      where = { ...where, wasteOriginTypeId: values.wasteOriginTypeId };
    }

    if (values.wasteDestinationTypeId) {
      where = { ...where, wasteDestinationTypeId: values.wasteDestinationTypeId };
    }

    if (values.addressNomos) {
      where = { ...where, '$collectionpoint.addressNomos$': values.addressNomos };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false }) => {
  // console.log('$$$-$ Filters Initial', initialValues);
  //
  const { authStore, appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    xAxisId: initialValues?.xAxisId ?? null,
    yAxisId: initialValues?.yAxisId ?? null,
    collectorId: initialValues?.collectorId ?? undefined,
    wastereceptionpointId: initialValues?.wastereceptionpointId ?? undefined,
    regionId: initialValues?.regionId ?? undefined,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldSelectXAxis as={Row} />
        <FieldDateRanger as={FormCol4} label="Συλλογή από" name="startDate" name2="endDate" />
        {appStore.isPlatformOwner && <FieldSelectCollector as={FormCol4} />}
      </Row>
      <Row>
        <FieldSelectYAxis as={Row} />

        <FieldSelectWasteReceptionPoint as={FormCol4} />

        <Field name="professionId">
          {({ form }) => (
            <FieldSelectProfession
              as={FormCol4}
              label="Επάγγελμα"
              name="professionId" // the select stores the id
              onChange={(opt: any) => {
                form.setFieldValue('professionId', opt?.value ?? null, true);
                form.setFieldValue('professionName', opt?.label ?? null, false); // used in where
              }}
            />
          )}
        </Field>
      </Row>
    </FormFilterCard>
  );
};
